import getSlackController from "./SlackController";
import { SlackAnimationStatus } from "../../lib/types";
import { deepChange } from "../../actions";

/**
 * Init slack module.
 * @param dispatch
 */
export const initSlackModule = (dispatch) => {
  const slackController: SlackController = getSlackController(dispatch);
  slackController.connect();
  dispatch(deepChange({ slackController }));
  dispatch(
    deepChange({
      "slackAnimation.typingAnimation": SlackAnimationStatus.hide,
    })
  );
};
export const deactivateSlackModule = (dispatch, getState) => {
  const state = getState();
  const slackController = state.slackController;
  if (slackController) {
    slackController.close();
    dispatch(deepChange({ slackController: null }));
  }
};
export const sendWSMessage = (messageText) => (dispatch, getState) => {
  const state = getState();
  const slackController = state.slackController;
  slackController.sendMessage(messageText);
};
